<script setup lang="ts">
import type { Article } from '~/models/content'

withDefaults(
  defineProps<{
    sectionOneArticles?: Article[]
    sectionTwoArticles?: Article[]
    sectionType?: 'one' | 'two'
  }>(),
  {
    sectionOneArticles: () => [],
    sectionTwoArticles: () => [],
    sectionType: 'one',
  },
)

const isDesktop = useDesktop()
</script>

<template>
  <!-- Section One Related Content -->
  <section
    v-if="sectionType === 'one'"
    aria-label="true"
    class="mt-8 px-5 lg:mt-0 lg:w-3/12 lg:px-0"
  >
    <SectionHeader title="Related content" />

    <div
      class="grid grid-cols-1 gap-5 md:basis-1/2 md:grid-cols-2 lg:grid-cols-1"
    >
      <VerticalCard
        v-for="article in sectionOneArticles"
        :key="article.id"
        :published-date="article.publishedDate"
        content-type="article"
        :slug="article.slug"
        :duration="article.duration"
        :title="article.title"
        :excerpt="article.excerpt"
        :pills="article.tags"
        :cover-url="article.coverUrl"
      />
    </div>
  </section>

  <!-- Section Two Related Content -->
  <section
    v-if="sectionType === 'two' && isDesktop"
    class="mt-32 hidden px-5 lg:block lg:px-0"
  >
    <SectionHeader title="Related content" />
    <section aria-label="true" class="grid grid-cols-4 gap-5">
      <VerticalCard
        v-for="article in sectionTwoArticles"
        :key="article.id"
        :published-date="article.publishedDate"
        content-type="article"
        :slug="article.slug"
        :duration="article.duration"
        :title="article.title"
        :excerpt="article.excerpt"
        :pills="article.tags"
        :cover-url="article.coverUrl"
      />
    </section>
  </section>
</template>
